import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import ChevronRight from '../../icons/chevron-right.svg';
import ExternalLink from '../../icons/external-link.svg';

const DesktopDropdownLink = (props) => {
  const { to, href, label, children } = props;

  let linkProps = {};

  if (href) {
    linkProps = { href, target: '_blank', rel: 'noreferrer', as: 'a' };
  } else if (to) {
    linkProps = { to };
  } else {
    linkProps = { as: 'button' };
  }

  if (!children) {
    return (
      // eslint-disable-next-line
      <DropdownLink {...linkProps}>
        {label} {href && <StyledExternalLink />}
      </DropdownLink>
    );
  }

  return (
    <Wrapper>
      <DropdownLink
        // eslint-disable-next-line
        {...linkProps}
      >
        {label} <StyledChevronRight />
      </DropdownLink>
      <SecondaryDropdownWrapper>
        <SecondaryDropdown>{children}</SecondaryDropdown>
      </SecondaryDropdownWrapper>
    </Wrapper>
  );
};

const DropdownLink = styled(Link)`
  white-space: nowrap;
  appearance: none;
  border: none;
  height: 42px;
  padding: 0 25px 0 15px;
  display: flex;
  align-items: center;
  background: white;
  text-decoration: none;
  border-radius: 4px;
  color: rgb(33, 33, 33);
  min-width: 200px;
  cursor: pointer;
  &:active,
  &:hover,
  &:focus {
    background: rgb(239, 241, 247);
  }
`;

const Wrapper = styled.div`
  position: relative;
`;

const SecondaryDropdownWrapper = styled.div`
  position: absolute;
  left: 100%;
  top: 0;
  width: 22px;
  height: 100%;
`;

const SecondaryDropdown = styled.div`
  position: absolute;
  top: 0;
  left: 5px;
  background: white;
  border-radius: 8px;
  padding: 5px;
  border: 1px solid rgb(220, 223, 232);
  box-shadow: 1px 1px 8px rgba(7, 32, 128, 0.15);
  display: flex;
  align-items: start;
  transition: all 0.1s linear;
  transform: translateY(-5px);

  opacity: 0;
  z-index: -100;
  pointer-events: none;

  ${Wrapper}:hover &, ${Wrapper}:focus-within & {
    transform: translateY(0);
    opacity: 1;
    z-index: 1;
    pointer-events: initial;
  }
`;

const StyledExternalLink = styled(ExternalLink)`
  margin-left: 10px;
`;

const StyledChevronRight = styled(ChevronRight)`
  margin-left: 10px;
  transition: all 0.2s linear;
  transform: translateX(0px);

  ${Wrapper}:hover & {
    transform: translateX(5px);
  }
`;

export default DesktopDropdownLink;
